import { ClientLanguageTestSubmission } from '../../lib/types/models/language-test/client-language-test-submission'
import { WithSectionNavigationContext } from '../../lib/types/models/language-test/language-test-submission'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const goToNextTestSection = (submissionId: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.goToNextSection.url, { submissionId }))
    .post<WithSectionNavigationContext<ClientLanguageTestSubmission>>()
